export default "__VITE_ASSET__b7ed0837__"